import { Box, Button, Center, Flex, Heading, Text } from '@chakra-ui/react';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import UserContext from '../../context/userContext';

function AuthOptions() {
  const { userData, setUserData } = useContext(UserContext);
  const history = useNavigate();

  const register = () => history('/register');
  const login = () => history('/login');
  const logout = () => {
    setUserData({
      token: undefined,
      user: undefined,
    });
    localStorage.setItem('auth-token', '');
  };

  return (
    <>
      <Box>
        {userData.user ? (
          <Box mt={5} mb={5}>
            <Flex direction="row" wrap="wrap" justify="center">
              <Heading>Welcome {userData.user.displayName}!</Heading>
            </Flex>
            <Flex direction="row" wrap="wrap" justify="center">
              <Button onClick={logout} colorScheme="messenger" size="lg" mt={3}>
                LOGOUT
              </Button>
            </Flex>
          </Box>
        ) : (
          <>
            <Box mt={5} mb={5}>
              <Flex direction="row" wrap="wrap" justify="center">
                <Button
                  onClick={register}
                  colorScheme="messenger"
                  size="lg"
                  mt={3}
                >
                  REGISTER
                </Button>
                <Button
                  ml={3}
                  onClick={login}
                  colorScheme="messenger"
                  size="lg"
                  mt={3}
                >
                  LOGIN
                </Button>
              </Flex>
              <Center>
                <Text w="60%" style={{ marginTop: 30 }}>
                  You have to register and login to be able to like and unlike
                  movies and to pick favorite moves. Login expires in 2 minutes.
                  Then you have to logout and login again. The email must be
                  unique.
                </Text>
              </Center>
            </Box>
          </>
        )}
      </Box>
    </>
  );
}

export default AuthOptions;
